import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function MarketplaceHistoryPage({ match }) {

  return (
    <Container
          location={{
            locationName: "History",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/marketplace/exports" />
    </Container>
  );
}

export default MarketplaceHistoryPage;